import { render } from "./FooterKikirpa.vue?vue&type=template&id=00259c00&scoped=true"
import script from "./FooterKikirpa.vue?vue&type=script&lang=js"
export * from "./FooterKikirpa.vue?vue&type=script&lang=js"

import "./FooterKikirpa.vue?vue&type=style&index=0&id=00259c00&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00259c00"]])

export default __exports__